<template>
  <VDropdown theme="ghost">
    <div class="relative inline-block">
      <button
        class="relative bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <svg
          class="h-6 w-6 inline-flex"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        <span
          v-show="hasUnread"
          class="absolute top-0 right-0 w-2 h-2 bg-red-600 rounded-full"
        ></span>
      </button>
    </div>

    <template #popper>
      <div class="py-1 w-80">
        <ul class="divide-y divide-gray-200 overflow-y-auto max-h-96">
          <template v-if="notifications.length">
            <li v-for="notification in notifications" :key="notification.id" class="">
              <NotificationListItem
                :notification="notification"
                @click="loadNotifications"
                @removed="loadNotifications({}, true)"
              />
            </li>
            <li v-if="hasMore">
              <BaseButton primary class="w-full" :disabled="loading" @click="loadMore">
                Load more ...
              </BaseButton>
            </li>
          </template>
          <li v-else class="px-4 py-2 text-sm">
            <p class="text-sm text-gray-600 py-3 text-center tracking-wide font-light">
              No unread messages
            </p>
          </li>
        </ul>
      </div>
    </template>
  </VDropdown>
</template>

<script>
import { marked } from 'marked';
import NotificationListItem from '@/components/Notifications/NotificationListItem.vue';

export default {
  name: 'Notifications',
  components: {
    NotificationListItem,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    notifications() {
      return this.$store.getters['ui/currentUserNotifications/notifications'];
    },
    notificationsMeta() {
      return this.$store.state.ui.currentUserNotifications.meta;
    },
    hasUnread() {
      const { total_unread: totalUnread = 0 } = this.notificationsMeta || {};
      return totalUnread > 0;
    },
    hasMore() {
      const { last_page: lastPage = 0, current_page: currentPage = 0 } = this.notificationsMeta;
      return lastPage > currentPage;
    },
  },
  created() {
    window.Echo.private(`App.User.${this.$user.id}`).notification((notification) => {
      this.loadNotifications({}, true);
      this.$toastr.info(marked(notification.message));
    });

    this.loadNotifications();
  },
  methods: {
    async loadNotifications(params = {}, replace = false) {
      if (this.loading) {
        return;
      }

      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/currentUserNotifications/load',
          params,
          replace,
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      this.loadNotifications({ page: this.notificationsMeta.current_page + 1 });
    },
  },
};
</script>
